export const useEmail = () => {
  const sendEmail = async (orderEmail, placedOrder, orderName, paymentMethod, language, orderId) => {
    try {
      await fetch(process.env.REACT_APP_SERVER_URL + "/api/user/sendemail", {
        method: "POST",
        body: JSON.stringify({ orderEmail, placedOrder, orderName, paymentMethod, language, orderId }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
    }
  };
  
  return { sendEmail };
};
